"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const BaseStyle_1 = require("./style/BaseStyle");
exports.BaseStyle = BaseStyle_1.BaseStyle;
const ButtonStyle_1 = require("./style/ButtonStyle");
exports.ButtonStyle = ButtonStyle_1.ButtonStyle;
const CheckStyle_1 = require("./style/CheckStyle");
exports.CheckStyle = CheckStyle_1.CheckStyle;
const IconStyle_1 = require("./style/IconStyle");
exports.IconStyle = IconStyle_1.IconStyle;
const ImageStyle_1 = require("./style/ImageStyle");
exports.ImageStyle = ImageStyle_1.ImageStyle;
const MenuStyle_1 = require("./style/MenuStyle");
exports.MenuStyle = MenuStyle_1.MenuStyle;
const MultilineTextStyle_1 = require("./style/MultilineTextStyle");
exports.MultilineTextStyle = MultilineTextStyle_1.MultilineTextStyle;
const NumberStyle_1 = require("./style/NumberStyle");
exports.NumberStyle = NumberStyle_1.NumberStyle;
const PercentCompleteBarStyle_1 = require("./style/PercentCompleteBarStyle");
exports.PercentCompleteBarStyle = PercentCompleteBarStyle_1.PercentCompleteBarStyle;
const Style_1 = require("./style/Style");
exports.Style = Style_1.Style;
const { EVENT_TYPE } = BaseStyle_1.BaseStyle;
exports.EVENT_TYPE = EVENT_TYPE;
function of(columnStyle, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
record, StyleClassDef = Style_1.Style) {
    if (columnStyle) {
        if (columnStyle instanceof BaseStyle_1.BaseStyle) {
            return columnStyle;
        }
        else if (typeof columnStyle === "function") {
            return of(columnStyle(record), record, StyleClassDef);
        }
        else if (record && columnStyle in record) {
            return of(record[columnStyle], record, StyleClassDef);
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return new StyleClassDef(columnStyle);
    }
    else {
        return StyleClassDef.DEFAULT;
    }
}
exports.of = of;
